import { render, staticRenderFns } from "./default_ReleaseApp.vue?vue&type=template&id=ca33fa2e&"
import script from "./default_ReleaseApp.vue?vue&type=script&lang=js&"
export * from "./default_ReleaseApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports